import type { ReactNode } from 'react';
import type { Transaction } from '@hero/schema';
import type { UseInfinitePaginationReturn } from '@hero/api-hooks';
import { useTranslation } from 'react-i18next';
import { SharedList } from '../../../app/List/List';
import { TransactionCard } from '../Card/TransactionCard';

export interface TransactionListProps {
  query: Pick<
    UseInfinitePaginationReturn<Transaction>,
    'data' | 'isLoading' | 'onLoadMore' | 'hasNextPage' | 'isFetchingNextPage'
  >;
  displayForUser: 'customer' | 'carrier';
  renderTransaction?: (transaction: Transaction) => ReactNode;
  className?: string;
}

export function TransactionList({
  query,
  displayForUser,
  renderTransaction,
  className,
}: TransactionListProps) {
  const { t } = useTranslation(['m-payment']);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <SharedList<Transaction>
        query={query}
        emptyMessage={t('m-payment:transaction.list.no_transactions')}
        className={className ?? 'gap-3 p-4'}
        renderItem={transaction =>
          renderTransaction ? (
            renderTransaction(transaction)
          ) : (
            <TransactionCard
              transaction={transaction}
              displayForUser={displayForUser}
            />
          )
        }
      />
    </div>
  );
}
